
import { ManageBlogs, CreateBlogs ,UpdateBlogs} from "../../../pages";
import adminRouteMap from "../../../routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.MANAGE_BLOGS.path,
      name: "Manage Blogs",
      key: adminRouteMap.MANAGE_BLOGS.path,
      private: true,
      belongsToSidebar: true,
      icon: adminRouteMap.MANAGE_BLOGS.icon,
      element: <ManageBlogs />,
    },
    {
      path: adminRouteMap.CREATE_BLOGS.path,
      name: "Manage Blogs",
      key: adminRouteMap.CREATE_BLOGS.path,
      private: true,
      belongsToSidebar: false,
      // icon: adminRouteMap.CREATE_BLOGS.icon,
      element: <CreateBlogs />,
    },
        {
      path: `${adminRouteMap.UPDATE_BLOGS.path}/:id`,
      name: "Update Blogs",
      key:  `${adminRouteMap.UPDATE_BLOGS.path}/:id`,
      private: true,
      belongsToSidebar: false,
      // icon: adminRouteMap.UPDATE_BLOGS.icon,
      element: <UpdateBlogs />,
    },
  ];
}
